import { faBolt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react";
import ProductRatingModal from "../product-rating-modal/ProductRatingModal";
import CertificateListService from "../../../services/CertificateListService";
import { selectProductRatings, updateProductRatings } from "../../../features/createCertificate/createCertificateSlice";
import { useDispatch, useSelector } from "react-redux";
import useToastr from "../../../hooks/useToastr";


const ProductRatingIcon = ({ model }: { model: any }) => {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const productRatings = useSelector(selectProductRatings);
  const dispatch = useDispatch();
  const { showError } = useToastr();


  const handleError = () => {
    showError(
      "Unable to Load Data",
      "Failed to fetch data. Please try again."
    );
    setVisible(false);
  };


  const fetchData = async () => {
    try {
      setLoading(true);

      const existing = productRatings.find(
        (x: any) => x.asset?.assetId === model?.assetId
      );

      if (existing) {
        setData(existing);
        return;
      }

      const res = await CertificateListService.getAssetProductRating(
        model?.assetId,
        model?.productType
      );

      if (!res.isSuccess) {
        handleError();
        return
      }

      if (res.data) {
        setData(res.data);
        dispatch(updateProductRatings(res.data));
      }
    } catch (err) {
      handleError()
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setVisible(true);

          if (!data) fetchData();
        }}
        title="Product Ratings"
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer"
        }}
      >
        <FontAwesomeIcon
          icon={faBolt}
          style={{ color: "#ffc107" }}
        />
      </button>

      <ProductRatingModal
        visible={visible}
        onHide={() => setVisible(false)}
        data={data}
        loading={loading}
        model={model}
      />
    </>
  );
};


export default ProductRatingIcon;
